var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.944 1.943a.83.83 0 0 1 1.173 0l14.94 14.939a.83.83 0 0 1-1.174 1.174l-2.618-2.618c-1.199.702-2.629 1.2-4.265 1.2-2.375 0-4.311-1.049-5.746-2.246-1.433-1.196-2.415-2.579-2.907-3.358l-.02-.031c-.097-.154-.224-.353-.288-.633a1.8 1.8 0 0 1 0-.742c.064-.28.191-.48.289-.633l.02-.032c.5-.791 1.515-2.22 3.005-3.437l-2.41-2.41a.83.83 0 0 1 0-1.173m5.196 6.37a3.32 3.32 0 0 0 4.546 4.546l-1.256-1.256A1.66 1.66 0 0 1 8.396 9.57z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.313 9.792a3.32 3.32 0 0 0-3.105-3.106l-2.87-2.87A8 8 0 0 1 10 3.36c2.375 0 4.311 1.05 5.746 2.247 1.433 1.196 2.415 2.578 2.907 3.357l.02.032c.097.153.224.353.288.633.052.225.052.516 0 .741-.064.28-.19.48-.288.633l-.02.031a15.3 15.3 0 0 1-1.791 2.306z"
  })));
};
export default SvgHide;